import React from 'react';
import {
  ChatContainerStyled,
  InfoStyled,
  ChevronStyled,
  ChatIconStyled,
  ContainerIconStyled,
} from './styles/OtherChannelsStyled';

import { redirectInternalOrExternal } from '../../../helpers/Redirect';

const OtherChannels = () => {
  return (
    <ChatContainerStyled
      onClick={() => {
        redirectInternalOrExternal('/ayuda/canales-atencion');
      }}
    >
      <ContainerIconStyled>
        <ChatIconStyled />
      </ContainerIconStyled>

      <InfoStyled>
        <h1>Otros canales de atención</h1>
        <h2>Contáctanos o visita una de nuestras sucursales</h2>
      </InfoStyled>
      <ChevronStyled />
    </ChatContainerStyled>
  );
};

export default OtherChannels;
